import _ from "lodash";
import { CriteriaDirectoryChargeCheckboxOption } from "presentation/constant/DocumentEnquiry/CriteriaDirectoryCheckboxOption";
import { DocumentEnquiryConstant } from "presentation/constant/DocumentEnquiry/DocumentEnquiryConstant";
import { useDocumentEnquiryVM } from "presentation/hook/DocumentEnquiry/useDocumentEnquiryVM";
import { useDocumentEnquiryTracked } from "presentation/store/DocumentEnquiry/DocumentEnquiryProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { FieldType, IFieldValue, NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import {
    GroupCheckboxList,
    HPHGroupCheckbox,
    HPHGroupTitle
} from "veronica-ui-component/dist/component/core";

export const DocumentEnquiryCriteriaEditChargePanel = () => {
    const DOC_ENQ_HDR_CONST = DocumentEnquiryConstant.Header;
    const [docEnquiryState] = useDocumentEnquiryTracked();
    const searchCriteria = docEnquiryState.searchCriteria
    const docEnquiryVM = useDocumentEnquiryVM();
    const enabledCriteria = useMemo(() => CriteriaDirectoryChargeCheckboxOption?.find(item => docEnquiryState.enabledSearchCriteria[item.key]), [docEnquiryState.enabledSearchCriteria])


    const memoSubChgTypeOptions = useMemo(() => {
        if (!searchCriteria.chgTypeList || searchCriteria.chgTypeList.length === 0) {
            const allCommonSubChgTypeOptions = Object.values(docEnquiryState.dynamicOptions.subChgTypeDropdownOptions).flat();
            return _.orderBy(_.uniqBy(_.flatMap(_.concat(allCommonSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        }
        const groupOfSubChgTypeOptions = searchCriteria.chgTypeList?.map(chgType => docEnquiryState.dynamicOptions.subChgTypeDropdownOptions[chgType])
        const commonSubChgTypeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfSubChgTypeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonSubChgTypeOptions;
    }, [docEnquiryState.dynamicOptions.subChgTypeDropdownOptions, searchCriteria.chgTypeList]);

    const memoChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.chgTypeList?.join(',')}
                fieldValue={searchCriteria.chgTypeList}
                fieldLabel={DOC_ENQ_HDR_CONST.CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chgTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={docEnquiryState.dynamicOptions.chgTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.CHARGE_TYPE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.chgTypeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => {
                    docEnquiryVM.onMultipleDropdownChange(e, 'chgTypeList')
                    docEnquiryVM.onDropdownChange(EMPTY_DOCUMENT_ENQUIRY_CRITERIA.subChgTypeList, 'subChgTypeList')
                }}
                options={docEnquiryState.dynamicOptions.chgTypeDropdownOptions} /> */}
        </div>
        , [searchCriteria.chgTypeList, docEnquiryState.dynamicOptions.chgTypeDropdownOptions, docEnquiryVM, DOC_ENQ_HDR_CONST.CHARGE_TYPE])

    const memoSubChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.subChgTypeList?.join(',')}
                fieldValue={searchCriteria.subChgTypeList}
                fieldLabel={DOC_ENQ_HDR_CONST.SUB_CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChgTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={memoSubChgTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.SUB_CHARGE_TYPE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.subChgTypeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => docEnquiryVM.onMultipleDropdownChange(e, 'subChgTypeList')}
                options={memoSubChgTypeOptions} /> */}
        </div>
        , [DOC_ENQ_HDR_CONST.SUB_CHARGE_TYPE, searchCriteria.subChgTypeList, memoSubChgTypeOptions, docEnquiryVM])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.billToCompList?.join(',')}
                fieldValue={searchCriteria.billToCompList}
                fieldLabel={DOC_ENQ_HDR_CONST.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={docEnquiryState.dynamicOptions.billToCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.BILL_TO_COMPANY}
                inputType="freeText"
                width="150px"
                mode={'multiple'}
                sort={false}
                isLimitOptions={true}
                value={searchCriteria.billToCompList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => docEnquiryVM.onMultipleDropdownChange(e, 'billToCompList')}
                options={docEnquiryState.dynamicOptions.billToCompDropdownOptions} /> */}
        </div>
        , [searchCriteria.billToCompList, docEnquiryVM, docEnquiryState.dynamicOptions.billToCompDropdownOptions, DOC_ENQ_HDR_CONST.BILL_TO_COMPANY])


    const memoOpsFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={DOC_ENQ_HDR_CONST.OPS_DATE_RANGE}
                width="330px"
                fieldNames={{ startField: "opsDateFrom", endField: "opsDateTo" }}
                dateRange={{ startDate: searchCriteria.opsDateFrom, endDate: searchCriteria.opsDateTo }}
                onDatesChange={docEnquiryVM.onDateRangeChange}
            />
        </div>
        , [searchCriteria.opsDateFrom, searchCriteria.opsDateTo, docEnquiryVM.onDateRangeChange, DOC_ENQ_HDR_CONST.OPS_DATE_RANGE])

    const memoBillingCycleCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.billingCycleCode || ''}
                fieldValue={searchCriteria.billingCycleCode}
                fieldLabel={DOC_ENQ_HDR_CONST.BILLING_CYCLE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billingCycleCode'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria.billingCycleCode, docEnquiryVM, DOC_ENQ_HDR_CONST.BILLING_CYCLE_CODE])

    // const memoBillingCycle = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <NbisInputDropDown
    //             label={DOC_ENQ_HDR_CONST.BILL_CYCLE}
    //             width='150px'
    //             inputType="freeText"
    //             mode={'multiple'}
    //             sort={false}
    //             value={searchCriteria.billingCycleList?.map((item) => ({
    //                 value: item
    //             }))}
    //             onChange={(e:any) => docEnquiryVM.onMultipleDropdownChange(e, 'billingCycleList')}
    //             options={billingTypeDropdownOption}/>
    //     </div>
    // , [searchCriteria.billingCycleList, docEnquiryVM, DOC_ENQ_HDR_CONST.BILL_CYCLE])

    const memoBillingCycle = useMemo(() =>
        <div className='im-flex-row-item'>
            <HPHGroupCheckbox
                label={DOC_ENQ_HDR_CONST.BILL_CYCLE}
                checkboxData={docEnquiryState.dynamicGroupCheckboxs.billingCycleCheckBoxOptions}
                selectedValues={searchCriteria.billingCycleList}
                orientation={"horizontal"}
                onChange={(e: (GroupCheckboxList | undefined)[]) => docEnquiryVM.onGroupCheckboxChange(e, "billingCycleList")}
            />
        </div>
        , [DOC_ENQ_HDR_CONST.BILL_CYCLE, docEnquiryState.dynamicGroupCheckboxs.billingCycleCheckBoxOptions, docEnquiryVM, searchCriteria.billingCycleList])

    // const memoBillingType = useMemo(() =>
    //         <div className='im-flex-row-item'>
    //             <NbisInputDropDown
    //                 label={DOC_ENQ_CONSTANT.BILLING_TYPE}
    //                 width='150px'
    //                 inputType="freeText"
    //                 mode={'multiple'}
    //                 sort={false}
    //                 value={searchCriteria.billingTypeList?.map((item) => ({
    //                     value: item
    //                 }))}
    //                 onChange={(e:any) => docEnquiryVM.onMultipleDropdownChange(e, 'billingTypeList')}
    //                 options={billingTypeDropdownOption}/>
    //         </div>
    //     , [searchCriteria.billingTypeList, docEnquiryVM, DOC_ENQ_CONSTANT.BILLING_TYPE])

    // const memoBillingType = useMemo(() =>
    //     <>
    //         <div className='im-flex-row-item'>
    //             <HPHGroupCheckbox
    //                 label={DOC_ENQ_HDR_CONST.BILLING_TYPE}
    //                 checkboxData={billingTypeCheckboxOption}
    //                 selectedValues={searchCriteria.billingTypeList}
    //                 orientation={"horizontal"}
    //                 onChange={(e: (GroupCheckboxList | undefined)[]) => docEnquiryVM.onGroupCheckboxChange(e, "billingTypeList")}
    //             />
    //         </div>
    //     </>
    //     , [DOC_ENQ_HDR_CONST.BILLING_TYPE, searchCriteria, docEnquiryVM])

    const memoCustCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.customerCodeList?.join(',')}
                fieldValue={searchCriteria.customerCodeList}
                fieldLabel={DOC_ENQ_HDR_CONST.CUST_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerCodeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={docEnquiryState.dynamicOptions.customerCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.CUST_CODE}
                inputType="freeText"
                width="330px"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.customerCodeList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => docEnquiryVM.onMultipleDropdownChange(e, 'customerCodeList')}
                options={docEnquiryState.dynamicOptions.customerCodeDropdownOptions} /> */}
        </div>
        , [DOC_ENQ_HDR_CONST.CUST_CODE, searchCriteria.customerCodeList, docEnquiryState.dynamicOptions.customerCodeDropdownOptions, docEnquiryVM])

    const memoHandlingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.handlingTmlList?.join(',')}
                fieldValue={searchCriteria.handlingTmlList}
                fieldLabel={DOC_ENQ_HDR_CONST.HANDLING_TML}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'handlingTmlList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={docEnquiryState.dynamicOptions.handlingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={DOC_ENQ_HDR_CONST.HANDLING_TML}
                width='330px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.handlingTmlList?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => {
                    docEnquiryVM.onMultipleDropdownChange(e, 'handlingTmlList')
                }}
                options={docEnquiryState.dynamicOptions.handlingTmlDropdownOptions} /> */}
        </div>
        , [DOC_ENQ_HDR_CONST.HANDLING_TML, searchCriteria.handlingTmlList, docEnquiryState.dynamicOptions.handlingTmlDropdownOptions, docEnquiryVM])

    const memoPoNumber = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.poNumber || ''}
                fieldValue={searchCriteria.poNumber}
                fieldLabel={DOC_ENQ_HDR_CONST.PO_NUMBER}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'poNumber'}
                maxLength={999}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    docEnquiryVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [DOC_ENQ_HDR_CONST.PO_NUMBER, searchCriteria.poNumber, docEnquiryVM])

    const memoPanel = useMemo(() => <div className='im-charge-data-search-criteria-group'>
        <HPHGroupTitle titleText={DOC_ENQ_HDR_CONST.CHARGE} />
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.chgTypeList ? <>{memoChgType}</> : null}
            {docEnquiryState.enabledSearchCriteria.subChgTypeList ? <>{memoSubChgType}</> : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.billToCompList ? memoBillToCompany : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.opsDate ? <>{memoOpsFromTo}</> : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.customerCodeList ? memoCustCode : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.billingCycleList ? memoBillingCycle : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.billingCycleCode ? memoBillingCycleCode : null}
        </CriteriaItemContainer>
        {/* <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.billingTypeList ? memoBillingType : null}
        </CriteriaItemContainer> */}
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.handlingTmlList ? memoHandlingTml : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {docEnquiryState.enabledSearchCriteria.poNumber ? memoPoNumber : null}
        </CriteriaItemContainer>
    </div>
        , [DOC_ENQ_HDR_CONST.CHARGE, docEnquiryState.enabledSearchCriteria.billToCompList, docEnquiryState.enabledSearchCriteria.billingCycleCode, docEnquiryState.enabledSearchCriteria.billingCycleList, docEnquiryState.enabledSearchCriteria.chgTypeList, docEnquiryState.enabledSearchCriteria.customerCodeList, docEnquiryState.enabledSearchCriteria.handlingTmlList, docEnquiryState.enabledSearchCriteria.opsDate, docEnquiryState.enabledSearchCriteria.poNumber, docEnquiryState.enabledSearchCriteria.subChgTypeList, memoBillToCompany, memoBillingCycle, memoBillingCycleCode, memoChgType, memoCustCode, memoHandlingTml, memoOpsFromTo, memoPoNumber, memoSubChgType]);

    if (!enabledCriteria) return null;
    return memoPanel;
};
